// Libraries
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';

// MUI
// Core
import { ResourceTextApplication } from '../../../../../core/resources';

// Common
import ViewLoader from '../../../../../common/ViewLoader';

// Interfaces
import { IAnimalAnnouncement, ICreatePreliminaryPurchaseAnnouncement, IUpdateAnnouncementResult } from '../../../../../interfaces/IAnnouncement';
import BovinePurchaseAnnouncement from '../BovinePurchaseAnnouncement';
import { AnnouncementTypeEnum, DialogModeEnum } from '../../../../../interfaces/enums';

// Store
// API
import animalAnnouncementApi from '../../../../../api/animalAnnouncementApi';
import { GUIDType } from '../../../../../interfaces/types';

interface IConfirmBovinePurchaseAnnouncementProps {
    announcement: IAnimalAnnouncement | null;
    onClose: () => void;
    processAnnouncementSave: (
        data: IUpdateAnnouncementResult,
        type: AnnouncementTypeEnum,
        holdingSiteId: string
    ) => void;
    processAnnouncementDelete: (announcementId: GUIDType) => void;
}

export default function ConfirmBovinePurchaseAnnouncement({
    announcement, onClose, processAnnouncementSave, processAnnouncementDelete
}: IConfirmBovinePurchaseAnnouncementProps) {
    return (
        <>
            {announcement ? (
                <BovinePurchaseAnnouncement
                    data={announcement}
                    onClose={onClose}
                    mode={DialogModeEnum.Edit}
                    processAnnouncementSave={processAnnouncementSave}
                    processAnnouncementDelete={processAnnouncementDelete}
                    announcementConfirmation
                    weekReadonly
                />
            ) : (
                <ViewLoader />
            )}
        </>
    );
}
